import { Injectable,inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserRolesService {
  private apiUrl = environment.apiUrl + '/user-roles/';  // Usa la variable global
  private http = inject(HttpClient); // Inyección sin constructor

  get():Observable<any>{
    return this.http.get(this.apiUrl+'get')
  }
  getById(id:string):Observable<any>{
    let headers = new HttpHeaders().set('Content-Type', 'application/json')
    return this.http.get(this.apiUrl+'getById/'+id)
  }
  update(id: string, userData: any): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.put(this.apiUrl + 'update/' + id, userData);
  }
}